import 'assets/fonts/fonts.css'
import 'styles/reset.css'
import { showVersion } from 'features/Env'
import { AppProviders } from './App.providers'
import { LayoutContent, LayoutHeader, Schedules } from './imports/App.components'

showVersion()

export function App() {
  return (
    <AppProviders>
      <LayoutHeader />

      <LayoutContent>
        <Schedules />
      </LayoutContent>
    </AppProviders>
  )
}
